import './styles/Loader.css'; // Make sure to create this CSS file and paste the styles there

const Loader = () => {
  return <div className="loader"></div>;
};

export default Loader;
